import { useTranslation } from "react-i18next"
import { EContractProfile } from "../../Enum/EContractProfile"
import { ERequestType } from "../../Enum/ERequestType"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { DownloadFileRequest } from "../../services/ApiClientService"

const CONTRACT_FILE_NAMES: Record<EContractProfile, string> = {
  [EContractProfile.Courier]: "contrato-entregador.pdf",
  [EContractProfile.RestaurantOwner]: "contrato-dono-restaurante.pdf",
  [EContractProfile.Customer]: "contrato-cliente-delivery.pdf",
}

export const useDownloadContract = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleDownloadContractAsync = async (
    profile: EContractProfile,
    requestType: ERequestType = ERequestType.Restaurant,
  ) => {
    try {
      enableLoad()

      const endpoint = `${API_ROUTES.CONTRACT.DOWNLOAD}?profile=${profile}`

      await DownloadFileRequest(endpoint, CONTRACT_FILE_NAMES[profile], requestType)
    } catch (e) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleDownloadContractAsync,
  }
}
